// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6d7f726c","667":"ce665fc5"}[chunkId] + ".chunk.js";
};